import React from 'react'
import Navbar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import OrderHostingForm from '../../components/pages/Services/Development/OrderHosting/OrderHostingForm'

const OrderHosting = () => {
  return (
    <div>
        <Navbar/>
        <OrderHostingForm/>
        <Footer/>
    </div>
  )
}

export default OrderHosting